module.exports = __webpack_public_path__ + "img/Statut_Processing.ff930c7a.svg";